module.exports = __webpack_public_path__ + "img/edge_patrimoine_historique.fa2d4ae6.svg";